import QualityButton from 'components/atoms/button/QualityButton';
import EmptyEntity from 'components/atoms/empty-entity/EmptyEntity';
import Input from 'components/atoms/input/Input';
import LoadingScreen from 'components/atoms/loading-screen/LoadingScreen';
import TextArea from 'components/atoms/text-area/TextArea';
import InputsFolder from 'components/molecules/inputs-folder/InputsFolder';
import QualitySlider from 'components/molecules/quality-slider/QualitySlider';
import UploadedFile from 'components/molecules/uploaded-file/UploadedFile';
import { IconType } from 'lib/helpers/constants/iconTypes';
import { useQuality } from 'lib/hooks/queries/Coustomer/useQuality';
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next';

export interface IUpdateQualityCheckProps {
  cusomterId: number;
}

const ViewQualityCheck: FC<IUpdateQualityCheckProps> = ({ cusomterId }) => {

  const { t } = useTranslation()


  const { data, isLoading } = useQuality(cusomterId)


  if (isLoading) return (
    <div className='relative h-full'>
      <LoadingScreen />
    </div>
  )

  return (
    <div className="flex flex-col gap-5 mb-0">
      <InputsFolder title={t("Quality check")}>
        <div className="flex flex-col gap-10">
          {data.question_data.length !== 0 ? (
            data.question_data.map((question :any) => (
            <div>
              <div className="flex items-center mb-7 gap-3">
                <div className="text-primaryTextColor font-inter-medium flex-1">
                  • {question.question}?
                </div>
              </div>
              {{ 
                'yes_no' : (
                  <QualityButton 
                    isChecked 
                    name="answer_three"
                    isNegative={question.answer === "No"}>
                    {question.answer ?? '-'}
                  </QualityButton>
                ),
                'short_text' : (
                  <Input
                    type="text"
                    disabled={true}
                    value={question.answer === null ? t("No answer added...") : question.answer}
                  />
                ),
                'long_text' : (
                  <TextArea
                    rows={4}
                    disabled={true}
                    value={question.answer === null ? t("No answer added...") : question.answer}
                />
                ),
                'rating_scale' : (
                  <div className="pb-7">
                    <QualitySlider
                      value={question.answer}
                    />
                  </div>
                ),
                'dropdown_selection' : (
                  <Input
                    type="text"
                    disabled={true}
                    value={question.answer === null ? t("No answer added...") : question.answer}
                  />
                ),
                'multiple_choice': (
                  <>
                    {Array.isArray(question.answer)
                      ? question.answer.join(', ')
                      : question.answer}
                  </>
                )
               }[question?.answer_type as string]}
            </div>
            ))
          ) : (
            <div> 
              <EmptyEntity classes={{ childrenclass: "text-center" }}>
                {t('No quality question answers have been added for this customer')}.
              </EmptyEntity>
            </div>
          )}
        </div>
      </InputsFolder>
      <InputsFolder
        title={t("Comments")}
        childrenClassName="max-h-[180px] h-full">
        <div className='font-inter text-primaryTextColor'>
          <TextArea
              rows={2}
              disabled={true}
              value={data.comment === null ? t("No comment added...") : data.comment}
          />
        </div>
      </InputsFolder>
      {(data.audio_one === null && data.pdf === null) ? null : (
        <InputsFolder title={t("Files")} childrenClassName="">
          <div className='space-y-5'>
            {data.audio_one === null ? null : (
              <UploadedFile
                icon={IconType.FILE_MP3_ICON}
                title={data.audio_one}
                linkName='costumers/quality'
                link={data.audio_one}
                updatedate={data.file_updated_at}
                isEditable={false}
                isAudio
              />
            )}
            {data.pdf === null ? null : (
              <UploadedFile
                icon={IconType.FILE_PDF_ICON}
                title={data.pdf}
                linkName='costumers/quality'
                link={data.pdf}
                updatedate={data.file_updated_at}
                isEditable={false}
              />
            )}
          </div>
        </InputsFolder>
      )}

    </div>
  )
}

export default ViewQualityCheck